import {graphqlQuery} from '../utils/graphqlQuery';

const OPERATION_NAME = 'graphql_get_urgency_message';
const urgencyMessageQuery = `
    query UnitMessage(
            $unitUuid: String!, 
            $dateRange: UrgencyDateRange, 
            $assetVersion: Int!, 
            $totalPrice: UnitTotalPrice, 
            $guests: UrgencyGuests,
            $isIpmNonGuaranteedPricing: Boolean!
        ) {
        unitMessage(
            unitUuid: $unitUuid, 
            dateRange: $dateRange, 
            assetVersion: $assetVersion,
            guests: $guests,
            totalPrice: $totalPrice,
            isIpmNonGuaranteedPricing: $isIpmNonGuaranteedPricing
        ) {
            iconText {
                message
                icon
                messageValueType
            }
            iconTitleText {
                icon
                link {
                    linkText
                    linkHref
                }
                message
                messageValueType
                title
            }
        }
    }
`;

// eslint-disable-next-line complexity
async function urgencyMessageGraphQl({
    unitUuid,
    startDate,
    endDate,
    assetVersion,
    locale,
    adults,
    children,
    hasPets,
    currency,
    price,
    isIpmNonGuaranteedPricing
}) {
    let params = {unitUuid, assetVersion, isIpmNonGuaranteedPricing};

    if (startDate && endDate) {
        params.dateRange = {startDate, endDate};
    }

    if (currency && price) {
        // total price param for urgency message is a string
        // https://github.homeawaycorp.com/GraphQL/graphql-traveler-urgency-messaging/blob/master/lib/types/UnitTotalPrice.gql#L3
        params.totalPrice = {currency, totalPrice: price.toString()};
    }

    if (adults) {
        params.guests = {adults};
        if (children) {
            params.guests = {
                ...params.guests,
                children
            };
        }
        if (hasPets) {
            params.guests = {
                ...params.guests,
                petIncluded: hasPets
            };
        }
    }
    const mutatedResponse = await graphqlQuery(OPERATION_NAME, urgencyMessageQuery, params, locale);

    return (mutatedResponse || {}).unitMessage || {};
}

export default urgencyMessageGraphQl;
export {urgencyMessageGraphQl, OPERATION_NAME, urgencyMessageQuery};
